function getIconSize(size) {
    switch(size){
        case '3xs':
            return '16';
        case '2xs':
            return '20';
        case 'xs':
            return '24';
        case 'sm':
            return '24';
        case 'md':
            return '24';
        case 'lg':
            return '28';
        default:
            return '24';
    }
}
export { getIconSize };
